import { CSRF_HEADER } from "@esi/shared";
import { createContext, useContext } from "react";

/** The signed-in instance operator (no tenant), as the console needs it. */
export interface OperatorSession {
  csrfToken: string;
  operatorId: string;
  /** From the operators' directory; null from an API that does not send them yet. */
  email: string | null;
  name: string | null;
}

const OperatorContext = createContext<OperatorSession | null>(null);

export const OperatorSessionProvider = OperatorContext.Provider;

export function useOperator(): OperatorSession {
  const value = useContext(OperatorContext);
  if (!value) {
    throw new Error("useOperator outside the console");
  }
  return value;
}

/** The CSRF header every console write sends. */
export function useCsrfHeaders() {
  const { csrfToken } = useOperator();
  return { headers: { [CSRF_HEADER]: csrfToken } };
}
